import React from 'react';
import { useTranslation } from 'react-i18next';
import ContactForm from '@/components/contact/ContactForm/ContactForm';
import ContactInfo from '@/components/contact/ContactInfo/ContactInfo';

const Contact: React.FC = () => {
  const { t } = useTranslation('contact');

  return (
    <div>
      <section className="py-20 min-h-[40vh] flex items-center">
        <div className="container-custom text-center">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 gradient-text">
            {t('header.title')}
          </h1>
          <p className="text-xl text-secondary max-w-2xl mx-auto">
            {t('header.subtitle')}
          </p>
        </div>
      </section>
      <ContactInfo />
      <ContactForm />
    </div>
  );
};

export default Contact;
